import React from 'react';
import '../../styles/landing/landing.scss';
import Grid from '@material-ui/core/Grid';
import Footer from '../includes/Footer';
import TermsItem from './TermsItem';

// function PrivacyPolicy(props) {
class PrivacyPolicy extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <React.Fragment>
        <div
          style={{
            maxWidth: '1024px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Grid
            spacing={0}
            container
            alignItems={'center'}
            justify={'center'}
            spacing={0}
            className="template-terms"
          >
            <Grid item md={12} sm={11} xs={11}>
              <span className="last-update">
                <span className="t-weight-b">Last update:</span> 5 May 2021
              </span>
              <h1 className="template-terms-main-title">Privacy Policy</h1>

              <TermsItem title="Luminaire Broker Privacy Notice">
                This privacy notice tells you what to expect us to do with your
                personal information when you make contact us about this
                service. We may change this privacy notice from time to time by
                updating this page. You should check this page from time to time
                to ensure you are happy with any changes.
                <br />
                <br />
                Luminaire Broker is a product from Arup. Our contact details
                are:
                <br />
                <br /> Name: Arup
                <br /> Address: 8 Fitzroy St, London W1T 4BJ
                <br /> E-mail: info@luminairebroker.com
              </TermsItem>
              <TermsItem
                title="What type of information we have"
                olTitle
                olTitle2
              >
                We currently collect and process the following information about
                you:
                <ul>
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Company name</li>
                  <li>Company address</li>
                  <li>Phone numbers</li>
                  <li>Mobile phone numbers</li>
                  <li>Profile pictures</li>
                </ul>
              </TermsItem>
              <TermsItem
                title="How we get the information and why we have it"
                olTitle
                olTitle2
              >
                Most of the personal information we process is provided to us
                directly by you for one of the following reasons:
                <ul>
                  <li>For opening an account</li>
                  <li>You’ve contacted us with a query about the service</li>
                </ul>
                Under the General Data Protection Regulation (GDPR), the lawful
                bases we rely on for processing this information is legitimate
                interest.
              </TermsItem>
              <TermsItem
                title="What we do with the information we have"
                olTitle
                olTitle2
              >
                We use the information that you have given us in order to
                operate this site and allow you to view specification
                requirements in order to respond to queries.
                <br />
                <br />
                We will not share your information with any third parties for
                the purposes of direct marketing.
                <br />
                <br />
                We use data processors who are third parties who provide
                elements of services for us. We have contracts in place with our
                data processors. This means that they cannot do anything with
                your personal information unless we have instructed them to do
                it. They will not share your personal information with any
                organisation apart from us. They will hold it securely and
                retain it for the period we instruct. 
                <br />
                <br />
                We also collect anonymised data for analytics of product
                specifications and suppliers’ response.
              </TermsItem>
              <TermsItem title="How we store your information" olTitle olTitle2>
                Your information is securely stored in the AWS cloud.
                <br />
                <br />
                We keep this information for as long as you have an account with
                us. We will then dispose of your information securely.
              </TermsItem>
              <TermsItem title="Your data protection rights" olTitle olTitle2>
                Under data protection law, you have the following rights:
                <br />
                <br />
                <b>Your right of access</b> - You have the right to ask us for
                copies of your personal information.
                <br />
                <br />
                <b>Your right to rectification</b> - You have the right to ask
                us to rectify information you think is inaccurate. You also have
                the right to ask us to complete information you think is
                incomplete.
                <br />
                <br />
                <b>Your right to erasure</b> - You have the right to ask us to
                erase your personal information in certain circumstances.
                <br />
                <br />
                <b>Your right to restriction of processing</b> - You have the
                right to ask us to restrict the processing of your information
                in certain circumstances.
                <br />
                <br />
                <b>Your right to object to processing</b> - You have the the
                right to object to the processing of your personal data in
                certain circumstances.
                <br />
                <br />
                You are not required to pay any charge for exercising your
                rights. If you make a request, we have one month to respond to
                you.
                <br />
                <br />
                Please contact us as above if you wish to make a request.
              </TermsItem>
              <TermsItem title="California residents" olTitle olTitle2>
                <p>
                  Under the California Consumer Privacy Act, California
                  residents have the right to request information about personal
                  data that we have collected from you, and to opt out from
                  commercial transactions of that data. Those residents may
                  contact us at Arup.AmericasPrivacy@arup.com or dial +1 833 814
                  2630.
                </p>
              </TermsItem>
              <TermsItem title="How to complain" olTitle olTitle2>
                <p>
                  You can also complain to the ICO if you are unhappy with how
                  we have used your data.
                </p>
                <br />
                <p>The ICO’s address:</p>
                <br />
                Information Commissioner’s Office
                <br />
                Wycliffe House
                <br />
                Water Lane
                <br />
                Wilmslow
                <br />
                Cheshire
                <br />
                SK9 5AF
                <br />
                Helpline number: 0303 123 1113
                <br />
              </TermsItem>
            </Grid>
          </Grid>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default PrivacyPolicy;
